import React from "react";
import Layout from "./HOCS/Layout";

const App = () => {
	return (
		<>
			<Layout />
		</>
	);
};

export default App;
